import React, { useContext } from "react";
import { useQuery } from "react-query";
import esurveylogonew from "../../assets/images/logo.png";
import { UserContext } from "../../routes/routes";
import { getOrganizationLogo } from "../../utils/ApiUrl";
import { axiosPost } from "../../utils/AxiosHelper";
import { queryClient } from "../../utils/common";
import { ToastTypeCode } from "../../utils/Constant";
import "./Header.scss";

interface LogoProps {
  orgId?: number;
}

const OrganizationLogo: React.FC<LogoProps> = ({ orgId }) => {
  const { appContextdata } = useContext<any>(UserContext);
  const organizationId = appContextdata?.Organization || orgId;
  const cachedLogo = queryClient.getQueryData<string>(["orglogo", organizationId]);

  const fetchLogo = async (organizationId: number): Promise<string> => {
    try {
      const response: any = await axiosPost(getOrganizationLogo, {
        OrganizationId: organizationId,
      });

      if (response?.data?.Status === 200 && response?.data?.ExtraData) {
        return response.data.ExtraData;
      } else {
        console.error("Error fetching organization logo", ToastTypeCode.ERROR);
        return esurveylogonew;
      }
    } catch (error) {
      console.error("Error fetching organization logo", ToastTypeCode.ERROR);
      return esurveylogonew;
    }
  };

  const {
    data: logoUrl,
    isError,
    isFetching,
  } = useQuery(["orglogo", organizationId], () => fetchLogo(organizationId as number), {
    enabled: !!organizationId,
    initialData: cachedLogo,
    retry: 1,
    onError: () => {
      console.error("Error fetching organization logo", ToastTypeCode.ERROR);
    },
  });

  const finalLogo = !isError && logoUrl ? logoUrl : esurveylogonew;

  return (
    <img
      src={finalLogo}
      className="esurveylogo"
      alt="logo"
      style={{ opacity: isFetching ? 0.6 : 1 }}
    />
  );
};

export default OrganizationLogo;
